import { createAction } from 'redux-actions'
import Api from '../Api'

export const UPDATE_EVENT_STAGE = createAction('UPDATE_EVENT_STAGE')
export const CREATE_EVENT_STAGE = createAction('CREATE_EVENT_STAGE')

export const createEventStage = (eventId, stage) => {
  return (dispatch) => {
    dispatch(UPDATE_EVENT_STAGE())

    return dispatch(CREATE_EVENT_STAGE(Api.createEventStage(eventId, stage)))
  }
}



// WEBPACK FOOTER //
// ./src/actions/event-stage.js